document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
      menuButton.textContent = isOpen ? 'Close' : 'Menu';
    });
  }

  const filterButton = document.querySelector('[data-filter-toggle]');
  const filterPanel = document.querySelector('[data-filter-panel]');
  if (filterButton && filterPanel) {
    filterButton.addEventListener('click', () => {
      filterPanel.hidden = !filterPanel.hidden;
      filterButton.setAttribute('aria-expanded', String(!filterPanel.hidden));
    });
  }

  const backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    const toggleBackToTop = () => backToTop.classList.toggle('is-visible', window.scrollY > 500);
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    toggleBackToTop();
    window.addEventListener('scroll', toggleBackToTop, { passive: true });
  }

  const variantSelect = document.querySelector('[data-variant-select]');
  const displayedPrices = document.querySelectorAll('[data-product-price]');
  const comparePrices = document.querySelectorAll('[data-product-compare-price]');
  const offerWidget = document.querySelector('[data-offer-widget]');
  const quantityInput = document.querySelector('[data-product-quantity]');
  const updateOffer = () => {
    if (!offerWidget || !quantityInput) return;
    const quantity = Math.max(1, Number(quantityInput.value) || 1);
    const cartCount = Number(offerWidget.dataset.cartCount) || 0;
    const cartTotal = Number(offerWidget.dataset.cartTotal) || 0;
    const unitPrice = Number(offerWidget.dataset.unitPrice) || 0;
    const itemCount = cartCount + quantity;
    const orderTotal = cartTotal + (unitPrice * quantity);
    const setStepState = (selector, currentState, projectedState) => {
      const step = offerWidget.querySelector(selector);
      if (!step) return;
      step.classList.toggle('is-active', currentState);
      step.classList.toggle('is-preview', !currentState && projectedState);
    };
    setStepState('[data-offer-step="ship"]', cartTotal >= 300000, orderTotal >= 300000);
    setStepState('[data-offer-step="2"]', cartCount >= 2, itemCount >= 2);
    setStepState('[data-offer-step="3"]', cartCount >= 3, itemCount >= 3);
    const progress = offerWidget.querySelector('[data-offer-progress]');
    if (progress) progress.style.width = `${Math.min(100, Math.max(orderTotal / 300000 * 33, itemCount / 3 * 100))}%`;
    const message = offerWidget.querySelector('[data-offer-message]');
    if (!message) return;
    if (cartCount >= 3) message.textContent = 'Your 10% multi-buy tier is already unlocked.';
    else if (itemCount >= 3) message.textContent = 'By adding this product to your bag, you’ll unlock 10% off.';
    else if (cartCount >= 2) message.textContent = 'Your 5% tier is active. Add this product to your bag to unlock 10% off.';
    else if (itemCount >= 2) message.textContent = 'By adding this product to your bag, you’ll unlock 5% off.';
    else if (cartTotal >= 300000) message.textContent = 'Free shipping is already unlocked for your bag.';
    else if (orderTotal >= 300000) message.textContent = 'By adding this product to your bag, you’ll unlock free shipping.';
    else message.textContent = 'Add this product to your bag to move closer to free shipping and multi-buy savings.';
  };
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      displayedPrices.forEach((price) => { price.textContent = option.dataset.price; });
      comparePrices.forEach((price) => {
        price.textContent = option.dataset.comparePrice || '';
        price.hidden = !option.dataset.comparePrice;
      });
      if (offerWidget) offerWidget.dataset.unitPrice = option.dataset.priceCents;
      updateOffer();
    });
  }
  quantityInput?.addEventListener('input', updateOffer);
  updateOffer();

  const cartTimer = document.querySelector('[data-cart-timer]');
  if (cartTimer) {
    const storageKey = 'ciaraCartReserveUntil';
    const now = Date.now();
    let reserveUntil = Number(sessionStorage.getItem(storageKey)) || 0;
    if (reserveUntil <= now) {
      reserveUntil = now + 5 * 60 * 1000;
      sessionStorage.setItem(storageKey, String(reserveUntil));
    }
    const renderCartTimer = () => {
      const secondsLeft = Math.max(0, Math.ceil((reserveUntil - Date.now()) / 1000));
      const minutes = Math.floor(secondsLeft / 60);
      const seconds = secondsLeft % 60;
      cartTimer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      if (secondsLeft <= 0) {
        reserveUntil = Date.now() + 5 * 60 * 1000;
        sessionStorage.setItem(storageKey, String(reserveUntil));
      }
    };
    renderCartTimer();
    window.setInterval(renderCartTimer, 1000);
  }

  const gallery = document.querySelector('[data-product-gallery]');
  const slides = gallery ? Array.from(gallery.querySelectorAll('[data-gallery-slide]')) : [];
  const current = document.querySelector('[data-gallery-current]');
  const dots = Array.from(document.querySelectorAll('[data-gallery-dot]'));
  const setGalleryIndex = (index) => {
    if (current) current.textContent = String(index + 1).padStart(2, '0');
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
  };
  dots.forEach((dot) => dot.addEventListener('click', () => {
    const index = Number(dot.dataset.galleryDot);
    slides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    setGalleryIndex(index);
  }));
  if (gallery && slides.length > 1) {
    let galleryFrame;
    gallery.addEventListener('scroll', () => {
      cancelAnimationFrame(galleryFrame);
      galleryFrame = requestAnimationFrame(() => setGalleryIndex(Math.round(gallery.scrollLeft / gallery.clientWidth)));
    }, { passive: true });
  }

  const reviewsButton = document.querySelector('[data-review-more]');
  const reviewGrid = document.querySelector('[data-review-grid]');
  reviewsButton?.addEventListener('click', () => {
    reviewGrid?.querySelectorAll('[hidden]').forEach((card) => { card.hidden = false; });
    reviewGrid?.classList.add('is-expanded');
    reviewsButton.hidden = true;
  });
  const reviewSort = document.querySelector('[data-review-sort]');
  reviewSort?.addEventListener('change', () => {
    if (!reviewGrid) return;
    const cards = Array.from(reviewGrid.querySelectorAll('[data-review-order]'));
    cards.sort((a, b) => reviewSort.value === 'oldest' ? Number(a.dataset.reviewOrder) - Number(b.dataset.reviewOrder) : Number(b.dataset.reviewOrder) - Number(a.dataset.reviewOrder));
    cards.forEach((card) => reviewGrid.appendChild(card));
  });
  const reviewDialog = document.querySelector('[data-review-dialog]');
  const reviewForm = document.querySelector('[data-review-form]');
  document.querySelector('[data-review-open]')?.addEventListener('click', () => reviewDialog?.showModal());
  document.querySelector('[data-review-close]')?.addEventListener('click', () => reviewDialog?.close());
  reviewForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    const success = reviewForm.querySelector('[data-review-success]');
    if (success) success.hidden = false;
    reviewForm.reset();
    window.setTimeout(() => {
      reviewDialog?.close();
      if (success) success.hidden = true;
    }, 1400);
  });

  const mainAtc = document.querySelector('[data-main-atc]');
  const stickyBar = document.querySelector('[data-sticky-atc-bar]');
  if (mainAtc && stickyBar) {
    const stickyObserver = new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
      document.body.classList.toggle('ciara-has-sticky-atc', visible);
    });
    stickyObserver.observe(mainAtc);
    stickyBar.querySelector('[data-sticky-atc]')?.addEventListener('click', () => document.querySelector('#CiaraProductForm')?.requestSubmit());
  }

  const loadMore = document.querySelector('[data-load-more]');
  const grid = document.querySelector('[data-product-grid]');
  if (loadMore && grid) {
    let loading = false;
    const observer = new IntersectionObserver(async ([entry]) => {
      if (!entry.isIntersecting || loading || !loadMore.dataset.nextUrl) return;
      loading = true;
      try {
        const response = await fetch(loadMore.dataset.nextUrl);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        html.querySelectorAll('[data-product-grid] .ciara-product-card').forEach((card) => grid.appendChild(card));
        const next = html.querySelector('[data-load-more]');
        if (next?.dataset.nextUrl) loadMore.dataset.nextUrl = next.dataset.nextUrl;
        else {
          observer.disconnect();
          loadMore.remove();
        }
      } catch (error) {
        loadMore.querySelector('span').textContent = 'Scroll to try again';
      } finally {
        loading = false;
      }
    }, { rootMargin: '300px 0px' });
    observer.observe(loadMore);
  }
});
